import React, { useState, useEffect } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { RiArrowRightSLine } from "react-icons/ri";
import {
  getRequest,
  putRequest,
  putWithFormData,
} from "../../helpers/api.helper";
import {
  EMPLOYMENT_OPTIONS,
  getEmploymentLabel,
} from "../../utils/employmentOptions";

const Step4Edit = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { id } = useParams();
  const { profile } = location.state || {};

  // Add profile check
  if (!profile) {
    return (
      <div className="flex justify-center items-center h-screen text-red-600 font-semibold">
        ⚠️ Profile data not available.
      </div>
    );
  }

  const [searchTerm, setSearchTerm] = useState("");
  const [searchTerm2, setSearchTerm2] = useState("");
  const [searchTerm3, setSearchTerm3] = useState("");
  const [modalData, setModalData] = useState<any>(null);
  const [modalData2, setModalData2] = useState<any | null>(null);
  const [modalData3, setModalData3] = useState<any>(null);

  const [city, setCity] = useState([]);
  const [education, setEducation] = useState([]);
  const [annualIncome, setAnnualIncome] = useState([]);
  const [occupation, setOccupation] = useState([]);
  const [extraSkills, setExtraSkills] = useState([]);

  // Initialize with profile data
  const [selectedOptions, setSelectedOptions] = useState<any>({
    Business_Location: profile?.businessLocation || [],
  });

  const [selectedOptions3, setSelectedOptions3] = useState<any>({
    extraSkills: profile?.extraTalentedSkills || [],
  });

  const [selectedOptions2, setSelectedOptions2] = useState<any>({
    Education: profile?.education
      ? { value: profile.education, label: profile.education }
      : null,
    Employment_Status: profile?.employmentStatus
      ? {
          value: profile.employmentStatus,
          label: getEmploymentLabel(profile.employmentStatus),
        }
      : null,
    occupation: profile?.occupation
      ? { value: profile.occupation, label: profile.occupation }
      : null,
    Anuual_Income: profile?.annualIncome
      ? { value: profile.annualIncome, label: profile.annualIncome }
      : null,
    Job_Location: profile?.jobLocation
      ? { value: profile.jobLocation, label: profile.jobLocation }
      : null,
    Any_Other_Bussiness: profile?.otherBusiness
      ? {
          value: profile.otherBusiness,
          label:
            profile.otherBusiness === "null" ? "None" : profile.otherBusiness,
        }
      : null,
    Other_Business_Income: profile?.otherBusinessIncome
      ? {
          value: profile.otherBusinessIncome,
          label: profile.otherBusinessIncome,
        }
      : null,
  });

  const dropdownOptions: any = {
    Business_Location: [
      ...city.map((job_location: any) => ({
        value: job_location.city,
        label: job_location.city,
      })),
    ],
  };

  const dropdownOptions3: any = {
    extraSkills: [
      ...extraSkills.map((skill: any) => ({
        value: skill.skill,
        label: skill.skill,
      })),
    ],
  };

  const dropdownOptions2: any = {
    Education: [
      ...education.map((education: any) => ({
        value: education.education,
        label: education.education,
      })),
    ],
    Employment_Status: EMPLOYMENT_OPTIONS,
    occupation: [
      ...occupation.map((occupation: any) => ({
        value: occupation.occupation,
        label: occupation.occupation,
      })),
    ],
    Anuual_Income: [
      ...annualIncome.map((annual_income: any) => ({
        value: annual_income.annual_income,
        label: annual_income.annual_income,
      })),
    ],
    Job_Location: [
      ...city.map((job_location: any) => ({
        value: job_location.city,
        label: job_location.city,
      })),
    ],
    Any_Other_Bussiness: [
      { value: "", label: "Select Business" },
      { value: "null", label: "None" },
      { value: "1", label: "1" },
      { value: "2", label: "2" },
      { value: "3", label: "3" },
      { value: "4", label: "4" },
    ],
    Other_Business_Income: [
      ...annualIncome.map((business_income: any) => ({
        value: business_income.annual_income,
        label: business_income.annual_income,
      })),
    ],
  };

  // Fetch dropdown data
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await getRequest("/common/profile/step4");
        if (response.success) {
          setCity(response.data.city || []);
          setEducation(response.data.education || []);
          setAnnualIncome(response.data.annual_income || []);
          setOccupation(response.data.occupation || []);
          setExtraSkills(response.data.extra_skills || []);
        }
      } catch (error) {
        console.error(`Error fetching data:`, error);
      }
    };
    fetchData();
  }, []);

  // Scroll to top on mount
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  // Reset search term when modal opens
  useEffect(() => {
    if (modalData) setSearchTerm("");
  }, [modalData]);

  useEffect(() => {
    if (modalData2) setSearchTerm2("");
  }, [modalData2]);

  useEffect(() => {
    if (modalData3) setSearchTerm3("");
  }, [modalData3]);

  const handleSelect = (selectedOption2: any) => {
    setSelectedOptions2({
      ...selectedOptions2,
      [modalData2.key]: selectedOption2,
    });
    closeModal2();
  };

  const handleCheckboxChange = (event: any, option: any) => {
    const { checked } = event.target;
    const updatedSelectedOptions = checked
      ? [...selectedOptions.Business_Location, option.value]
      : selectedOptions.Business_Location.filter(
          (lang: any) => lang !== option.value
        );

    setSelectedOptions({
      ...selectedOptions,
      Business_Location: updatedSelectedOptions,
    });
  };

  const handleCheckboxChange2 = (event: any, option: any) => {
    const { checked } = event.target;
    const updatedSelectedOptions3 = checked
      ? [...selectedOptions3.extraSkills, option.value]
      : selectedOptions3.extraSkills.filter(
          (skill: any) => skill !== option.value
        );

    setSelectedOptions3({
      ...selectedOptions3,
      extraSkills: updatedSelectedOptions3,
    });
  };

  const openModal = (key: any) =>
    setModalData({ key, options: dropdownOptions[key] });
  const closeModal = () => setModalData(null);

  const openModal2 = (key: any) =>
    setModalData2({ key, options: dropdownOptions2[key] });
  const closeModal2 = () => setModalData2(null);

  const openModal3 = (key: any) =>
    setModalData3({ key, options: dropdownOptions3[key] });
  const closeModal3 = () => setModalData3(null);

  const handleSubmit = async (e: any) => {
    e.preventDefault();

    const formattedOptions = {
      education: selectedOptions2.Education?.value || "",
      employmentStatus: selectedOptions2.Employment_Status?.value || "",
      occupation: selectedOptions2.occupation?.value || "",
      annualIncome: selectedOptions2.Anuual_Income?.value || "",
      jobLocation: selectedOptions2.Job_Location?.value || "",
      otherBusinessIncome: selectedOptions2.Other_Business_Income?.value || "",
      otherBusiness: selectedOptions2.Any_Other_Bussiness?.value || "",
    };

    const dataToSend = {
      ...formattedOptions,
      extraTalentedSkills: selectedOptions3.extraSkills || [],
      businessLocation: selectedOptions.Business_Location || [],
      step1: 1,
      step2: 1,
      step3: 1,
      step4: 1,
    };

    try {
      const response = await putRequest(
        `/bureau/profile/${profile._id}`,
        dataToSend
      );
      if (response.success) {
        alert("Details updated successfully!");
        navigate(-1);
      } else {
        alert("Failed to update details.");
      }
    } catch (error: any) {
      console.error("Error updating details:", error.message);
    }
  };

  const handleBackClick = () => {
    navigate(-1);
  };

  return (
    <div className="profile-edit-page flex justify-center items-center min-h-screen bg-gradient-to-r from-blue-50 to-indigo-100">
      <div className="w-full max-w-lg bg-white shadow-lg rounded-lg">
        {/* Header */}
        <div className="w-full z-50 bg-red-600 fixed top-0 mb-12 p-2 px-3 flex items-center justify-center">
          <div className="flex items-center gap-2">
            <button className="flex items-center" onClick={handleBackClick}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-6 w-6 text-white"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                strokeWidth={2}
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M15 19l-7-7 7-7"
                />
              </svg>
            </button>
            <h1 className="text-2xl font-bold text-center text-white py-3">
              Step 4 -
            </h1>
            <h5 className="font-semibold text-white">Education Details</h5>
          </div>
        </div>

        {/* Form */}
        <form
          className="space-y-6 mt-20 py-4 px-3 z-99"
          onSubmit={handleSubmit}
        >
          {/* Single Select Fields */}
          {Object.keys(dropdownOptions2).map((key) => (
            <div key={key}>
              <label className="block text-red-500 font-medium mb-2">
                {key}
              </label>
              <div
                className="flex flex-col w-full border px-3 border-gray-300 py-3 cursor-pointer rounded-lg hover:shadow-lg transition-all"
                onClick={() => openModal2(key)}
              >
                <div className="flex items-center justify-between">
                  <span className="text-gray-500 text-md font-medium">
                    {selectedOptions2[key]?.label || `Select ${key}`}
                  </span>
                  <RiArrowRightSLine className="text-3xl text-gray-500 ml-3" />
                </div>
              </div>
            </div>
          ))}

          {/* Multi Select: Business Location */}
          {Object.keys(dropdownOptions).map((key) => (
            <div key={key} className="rounded-lg">
              <label className="block text-red-500 font-medium mb-2 capitalize">
                {key}
              </label>
              <div
                className="flex flex-col w-full border px-3 border-gray-300 py-3 rounded-lg cursor-pointer hover:shadow-lg transition-all"
                onClick={() => openModal(key)}
              >
                <div className="flex items-center justify-between rounded">
                  <span className="text-gray-500 text-md font-medium">
                    {selectedOptions[key]?.length
                      ? dropdownOptions[key]
                          .filter((opt: any) =>
                            selectedOptions[key].includes(opt.value)
                          )
                          .map((lang: any) => lang.label)
                          .join(", ")
                      : `Select ${key}`}
                  </span>
                  <RiArrowRightSLine className="text-3xl text-gray-500 ml-3" />
                </div>
              </div>
            </div>
          ))}

          {/* Multi Select: Extra Skills */}
          {Object.keys(dropdownOptions3).map((key) => (
            <div key={key} className="rounded-lg">
              <label className="block text-red-500 font-medium mb-2 capitalize">
                {key}
              </label>
              <div
                className="flex flex-col w-full border px-3 border-gray-300 py-3 rounded-lg cursor-pointer hover:shadow-lg transition-all"
                onClick={() => openModal3(key)}
              >
                <div className="flex items-center justify-between rounded">
                  <span className="text-gray-500 text-md font-medium">
                    {selectedOptions3[key]?.length
                      ? dropdownOptions3[key]
                          .filter((opt: any) =>
                            selectedOptions3[key].includes(opt.value)
                          )
                          .map((skill: any) => skill.label)
                          .join(", ")
                      : `Select ${key}`}
                  </span>
                  <RiArrowRightSLine className="text-3xl text-gray-500 ml-3" />
                </div>
              </div>
            </div>
          ))}

          <button
            type="submit"
            className="w-full bg-red-600 text-white p-3 rounded-lg hover:bg-red-800"
          >
            Update
          </button>
        </form>

        {/* Modal 1: Multi-select for Business Location */}
        {modalData && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
            <div className="bg-white p-6 rounded-lg max-w-md w-full shadow-lg m-5">
              <h2 className="text-lg font-bold mb-4 capitalize text-center">
                Select {modalData.key}
              </h2>

              <input
                type="text"
                className="w-full px-4 py-2 mb-4 border border-gray-300 rounded focus:outline-none focus:ring focus:ring-blue-200"
                placeholder={`Search ${modalData.key}`}
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />

              <div className="h-64 overflow-y-auto border-t border-b border-gray-200">
                {modalData.options
                  .filter((option: any) =>
                    option.label
                      .toLowerCase()
                      .includes(searchTerm.toLowerCase())
                  )
                  .map((option: any, index: any) => (
                    <React.Fragment key={index}>
                      <div className="flex items-center space-x-2 py-2">
                        <input
                          type="checkbox"
                          checked={selectedOptions.Business_Location.includes(
                            option.value
                          )}
                          onChange={(e) => handleCheckboxChange(e, option)}
                          className="form-checkbox h-4 w-4 text-red-600"
                        />
                        <label className="block text-gray-700">
                          {option.label}
                        </label>
                      </div>
                      <hr className="border-gray-200" />
                    </React.Fragment>
                  ))}
              </div>

              <button
                className="mt-4 w-full px-4 py-2 bg-red-500 text-white rounded hover:bg-red-600 transition"
                onClick={closeModal}
              >
                Continue
              </button>
            </div>
          </div>
        )}

        {/* Modal 2: Single-select */}
        {modalData2 && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
            <div className="bg-white p-6 rounded-lg max-w-md w-full shadow-lg m-5">
              <h2 className="text-lg font-bold mb-4 capitalize text-center">
                Select {modalData2.key}
              </h2>

              <input
                type="text"
                className="w-full px-4 py-2 mb-4 border border-gray-300 rounded focus:outline-none focus:ring focus:ring-blue-200"
                placeholder={`Search ${modalData2.key}`}
                value={searchTerm2}
                onChange={(e) => setSearchTerm2(e.target.value)}
              />

              <div className="h-64 overflow-y-auto border-t border-b border-gray-200">
                {modalData2.options
                  .filter((option: any) =>
                    option.label
                      .toLowerCase()
                      .includes(searchTerm2.toLowerCase())
                  )
                  .map((option: any, index: any) => (
                    <React.Fragment key={index}>
                      <button
                        className="block w-full text-left px-4 py-2 hover:bg-gray-100 transition"
                        onClick={() => handleSelect(option)}
                      >
                        {option.label}
                      </button>
                      <hr className="border-gray-200" />
                    </React.Fragment>
                  ))}
              </div>

              <button
                className="mt-4 w-full px-4 py-2 bg-red-500 text-white rounded hover:bg-red-600 transition"
                onClick={closeModal2}
              >
                Continue
              </button>
            </div>
          </div>
        )}

        {/* Modal 3: Multi-select for Extra Skills */}
        {modalData3 && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
            <div className="bg-white p-6 rounded-lg max-w-md w-full shadow-lg m-5">
              <h2 className="text-lg font-bold mb-4 capitalize text-center">
                Select {modalData3.key}
              </h2>

              <input
                type="text"
                className="w-full px-4 py-2 mb-4 border border-gray-300 rounded focus:outline-none focus:ring focus:ring-blue-200"
                placeholder={`Search ${modalData3.key}`}
                value={searchTerm3}
                onChange={(e) => setSearchTerm3(e.target.value)}
              />

              <div className="h-64 overflow-y-auto border-t border-b border-gray-200">
                {modalData3.options
                  .filter((option: any) =>
                    option.label
                      .toLowerCase()
                      .includes(searchTerm3.toLowerCase())
                  )
                  .map((option: any, index: any) => (
                    <React.Fragment key={index}>
                      <div className="flex items-center space-x-2 py-2">
                        <input
                          type="checkbox"
                          checked={selectedOptions3.extraSkills.includes(
                            option.value
                          )}
                          onChange={(e) => handleCheckboxChange2(e, option)}
                          className="form-checkbox h-4 w-4 text-red-600"
                        />
                        <label className="block text-gray-700">
                          {option.label}
                        </label>
                      </div>
                      <hr className="border-gray-200" />
                    </React.Fragment>
                  ))}
              </div>

              <button
                className="mt-4 w-full px-4 py-2 bg-red-500 text-white rounded hover:bg-red-600 transition"
                onClick={closeModal3}
              >
                Continue
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default Step4Edit;
